/**
 * Created by Mark on 19/04/2017.
 */

import React, { Component } from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import FormControl from 'react-bootstrap/lib/FormControl';
import Alert from 'react-bootstrap/lib/Alert';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormGroup from '../inputs/fg-input.js';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import ButtonToolbar  from 'react-bootstrap/lib/ButtonToolbar';
import Button  from 'react-bootstrap/lib/Button';
import { FormattedMessage } from 'react-intl';
import StaffTypeSelector from '../inputs/staff-types-selector.js';
import StaffService from '../../services/staff-services.js';
import BulkImport from './teacher-bulk-import.js';
import Select from  'react-select';
import ClassSelector from '../inputs/classes-selector.js';

export default class StaffForm extends React.Component{

    constructor(props) {
        super();
        this.state = {set:false , passwordChanged:false , selectedClasses:[] , classes:[] , user_type:{value:'school_teacher'} ,  firstName:'' , lastName:'' , password:'' , passwordConfirm:'' , email:'' ,  canCreate:false ,
            validations:{}
        };

        this.handelPasswordChange = this.handelPasswordChange.bind(this);
        this.handelPasswordConfirmChange = this.handelPasswordConfirmChange.bind(this);
        this.handelEmailChange = this.handelEmailChange.bind(this);
        this.handelFirstNameChange = this.handelFirstNameChange.bind(this);
        this.handelLastNameChange = this.handelLastNameChange.bind(this);
        this.onUserTypeChange = function(vaule){

            this.setState({user_type:vaule})

        }.bind(this);

    }

    onSelect(selectedClasse){
        this.setState({selectedClasses:selectedClasse})
    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;

        if(this.state.set === true ) return;

        const classes = (nextProps.teacher.classes || [] ).map(function(_class){
            return {value:_class.uid , label:_class.name}
        });

        this.setState({
            uid:nextProps.teacher.uid,
            firstName:nextProps.teacher.name.split(' ')[0] || this.state.firstName,
            lastName:nextProps.teacher.name.split(' ').slice(-1).join(' ') || this.state.lastName,
            email:nextProps.teacher.username || this.state.email,
            password:nextProps.teacher.password || "*******",
            passwordConfirm:nextProps.teacher.password || "*******",
            classes:classes,
            selectedClasses:classes,
            passwordChanged:false,
            set:true
        });

        this.setValidation('name'     , true);
        this.setValidation('email' , true);
        this.setValidation('password' , true);
    }

    handelFirstNameChange(e){
        this.setState({firstName:e.target.value});
        this.setValidation('name' , this.validateName());
        this.setState({nameHelp:this.validateName() ? null : <HelpBlock><FormattedMessage id={ 'ui-537' } defaultMessage={ 'Please Enter Full Name' }/></HelpBlock>})
    }

    handelLastNameChange(e){
        this.setState({lastName:e.target.value});
        this.setValidation('name' , this.validateName());
        this.setState({nameHelp:this.validateName() ? null : <HelpBlock><FormattedMessage id={ 'ui-537' } defaultMessage={ 'Please Enter Full Name' }/></HelpBlock>})
    }

    validateName(){
        return this.state.firstName.length >= 1 && this.state.lastName.length >= 1
    }


    validateEmailRegex(email){
        var regex = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i

        if(!regex.test(email)){
            this.setValidation('email' , false);
            this.setState({emailHelp:<HelpBlock><FormattedMessage id={ 'ui-36' } defaultMessage={ 'Email is invaild' }/></HelpBlock>})
            return false;
        }

        return true
    }

    validateEmail(email){

        if(!this.validateEmailRegex(email)) return;

        return StaffService.isEmailAvaliable(email).then(function(isValid){
            this.setValidation('email' , isValid);
            this.setState({emailHelp:isValid ? null : <HelpBlock><FormattedMessage id={ 'ui-12' } defaultMessage={ 'Email has been taken' }/></HelpBlock>})
        }.bind(this));
    }

    handelEmailChange(e){
        this.setState({email:e.target.value});
        this.validateEmail(e.target.value);
    }

    handelPasswordConfirmChange(e){
        this.setValidation('password' , e.target.value == this.state.password);
        this.setState({passwordConfirm:e.target.value , passwordChanged:true , passHelp: e.target.value == this.state.password ? null : <HelpBlock><FormattedMessage id={ 'ui-539' } defaultMessage={ 'Passwords do not match' }/></HelpBlock>})
    }

    handelPasswordChange(e){
        this.setValidation('password' , e.target.value == this.state.passwordConfirm);
        this.setState({password:e.target.value , passwordChanged:true , passHelp:e.target.value == this.state.passwordConfirm ? null : <HelpBlock><FormattedMessage id={ 'ui-539' } defaultMessage={ 'Passwords do not match' }/></HelpBlock>})
    }

    getValidationState(vaule , valid) {
        if(vaule.length == 0) return null;
        return valid ? 'success' : 'error'
    }

    setValidation(key , isVaild){
        var validations = this.state.validations;
            validations[key] = isVaild;
        this.setState({validations:validations})
        this.canCreate();
    }

    canCreate(){

        console.log(this.state.validations)
        for(let key in this.state.validations){
            if(!this.state.validations.hasOwnProperty(key)) continue;
            if(this.state.validations[key] == false) return this.setState({canCreate:false})
        }

        this.setState({canCreate:true});
    }

    handelFormSubmit(){



        StaffService.editStaff(this.state.uid , this.state.firstName , this.state.lastName , this.state.password , this.state.email , this.state.passwordChanged , this.state.selectedClasses).then(function(response){
            if(response.completed)
            {
                if(this.props.onCreated) this.props.onCreated();
                this.setState({user_type:{value:'school_teacher'} , firstName:'' , lastName:'' , password:'' , passwordConfirm:'' , email:'' , created:true , canCreate:false , validations:{}});
            }
            else
            {

            }
        }.bind(this))
    }

    render() {

        let createButton = React.createElement(Button, {
            onClick:  this.handelFormSubmit.bind(this),
            disabled: !this.state.canCreate,
            bsStyle:'primary',
            className:"btn-block"
        }, <FormattedMessage id="ui-254" defaultMessage="Submit"/>);

        let message = null;
        if(this.state.created)
        {
            message =  <Alert key="wizard-alert" className="p-5" bsStyle="success"><center><strong>Staff member has been created</strong></center></Alert>
        }

        return <Row className="p-l-10 , p-r-10">
                    <Row>
                        <Col sm={6}>
                            <FormGroup  helpBlock={this.state.nameHelp} controlId="formBasicText" validationState={this.getValidationState(this.state.firstName , this.state.validations.name)}>
                                <ControlLabel className="fg-label"><FormattedMessage id={ 'ui-579' } defaultMessage={ 'First Name' }/></ControlLabel>
                                <FormControl value={this.state.firstName} type="text" onChange={this.handelFirstNameChange} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup controlId="formBasicText" validationState={this.getValidationState(this.state.lastName , this.state.validations.name)}>
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-580' } defaultMessage={ 'Last Name' }/></ControlLabel>
                                <FormControl value={this.state.lastName} type="text" onChange={this.handelLastNameChange}/>

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup helpBlock={this.state.emailHelp} controlId="formBasicText" validationState={this.getValidationState(this.state.email , this.state.validations.email)}>
                                    <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-9' } defaultMessage={ 'Email' }/></ControlLabel>
                                    <FormControl value={this.state.email} type="text" onChange={this.handelEmailChange}/>

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup helpBlock={this.state.passHelp} validationState={this.getValidationState(this.state.password , this.state.validations.password)}>
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-23' } defaultMessage={ 'Password' }/></ControlLabel>
                                <FormControl value={this.state.password} type="password" onChange={this.handelPasswordChange}/>

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup controlId="formBasicText" validationState={this.getValidationState(this.state.passwordConfirm , this.state.validations.password)}>
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-531' } defaultMessage={ 'Confirm Password' }/></ControlLabel>
                                <FormControl value={this.state.passwordConfirm} type="password" onChange={this.handelPasswordConfirmChange}/>

                            </FormGroup>
                        </Col>
                    </Row>
                <Row>
                <Col sm={12}>
                    <FormGroup controlId="formBasicText" >
                        <ControlLabel  className="fg-label"><FormattedMessage id={ 'ui-320' } defaultMessage={ 'Classes' }/></ControlLabel>
                        <ClassSelector multi onSelect={this.onSelect.bind(this)} value={this.state.selectedClasses} options={this.state.classes}/>
                    </FormGroup>
                </Col>
                </Row>
                    <Row>
                        <Col sm={8}>
                            {message}
                          </Col>
                        <Col sm={4}>{createButton}</Col>
                    </Row>
        </Row>
    }
};


// WEBPACK FOOTER //
// ./src/components/forms/teacher-edit-form.js